import { keyBy, uniqBy } from 'lodash-es';

import { selectors, useAppSelector } from 'state/global-state';
import {
  ICartEntryType,
  useInRestaurantRedemptionContext,
} from 'state/loyalty/in-restaurant-redemption';
import { LoyaltyOffer } from 'state/loyalty/types';

export const useLoyaltyOffersInCart = () => {
  const { inRestaurantRedemptionCart } = useInRestaurantRedemptionContext();
  const appliedOffers = useAppSelector(selectors.loyalty.selectAppliedOffers);
  const cmsOffers = useAppSelector(selectors.loyalty.selectCmsOffers);
  const personalizedOffers = useAppSelector(selectors.loyalty.selectPersonalizedOffers);

  const getLoyaltyOffersInCart = () => {
    const appliedOffersMap = keyBy(appliedOffers, 'id');
    const inRestaurantRedemptionMap = keyBy(inRestaurantRedemptionCart, cartEntry =>
      cartEntry.type === ICartEntryType.OFFER ? cartEntry.details.offer._id : cartEntry.referenceId
    );

    const offers: LoyaltyOffer[] = uniqBy([...personalizedOffers, ...cmsOffers], 'loyaltyEngineId');
    return offers?.filter((offer: LoyaltyOffer) => {
      if (!offer.loyaltyEngineId || !offer._id) {
        return false;
      }
      return appliedOffersMap[offer.loyaltyEngineId] || inRestaurantRedemptionMap[offer._id];
    });
  };

  // For now we can have only one offer in cart, so taking the first one is valid.
  const getLoyaltyOfferInCart = (): LoyaltyOffer | undefined => {
    return getLoyaltyOffersInCart()[0];
  };

  return {
    getLoyaltyOfferInCart,
  };
};
